module.exports = (__webpack_require__(56935))(1839);